import { render, staticRenderFns } from "./fccConfiguracaoDefinida.vue?vue&type=template&id=ac4b2c62"
import script from "./fccConfiguracaoDefinida.vue?vue&type=script&lang=js"
export * from "./fccConfiguracaoDefinida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports